import bannerGeneratorActions from "../actions/bannerGenerator";

const mainState = {
  title: "فروش ویژه",
  description: "تخفیف های شگفت انگیز ويژه زمستان سرد",
  titleButton: "مشاهده",
  colorButton: "",
  logoBrand: "",
  imageBrand: "",
  backgroundColorDetailsArea: "",
  borderRadiusButton: 10,
};

const main = (state = mainState, action) => {
  let newState = state;
  switch (action.type) {
    case bannerGeneratorActions.SET_TITLE:
      newState = {
        ...state,
        title: action.payload.title,
      };
      break;

    case bannerGeneratorActions.SET_DESCRIPTION:
      newState = {
        ...state,
        description: action.payload.description,
      };
      break;

    case bannerGeneratorActions.SET_COLOR_BUTTON:
      newState = {
        ...state,
        colorButton: action.payload.colorButton,
      };
      break;

    case bannerGeneratorActions.SET_TITLE_BUTTON:
      newState = {
        ...state,
        titleButton: action.payload.titleButton,
      };
      break;
    case bannerGeneratorActions.SET_LOGO:
      newState = {
        ...state,
        logoBrand: action.payload.logoBrand,
      };
      break;
    case bannerGeneratorActions.SET_BANNER:
      newState = {
        ...state,
        imageBrand: action.payload.imageBrand,
      };
      break;
    case bannerGeneratorActions.SET_BACKGROUND_COLOR_DETAILS_AREA:
      newState = {
        ...state,
        backgroundColorDetailsArea: action.payload.backgroundColorDetailsArea,
      };
      break;
    case bannerGeneratorActions.SET_BORDER_RADIUS_BUTTON:
      newState = {
        ...state,
        borderRadiusButton: action.payload.borderRadiusButton,
      };
      break;
  }
  return newState;
};

export default main;
